import React from 'react';

import { AnnouncementContext } from './context';

const AnnouncementConsumer = ({ children }) => {
  return (
    <AnnouncementContext.Consumer>{(context) => children(context)}</AnnouncementContext.Consumer>
  );
};

export default AnnouncementConsumer;
